import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StandingService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  // [GET] tournament standings
  public getTournamentStandings(tournamentId: string, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    const apiEndpoint = _.reduce(
      [[':type', type], [':tournament', tournamentId]],
      (res, [key, replacement]) => _.replace(res, key!, replacement!),
      environment.api_endpoints.tournamentStandings
    );
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + apiEndpoint, {
        params: {}, observe: 'response'
      });
  }

  // [PATCH] tournament standings positions
  public updateStandingsPositions(positions: any[], type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.tournamentStandingsPositions, ':type', type),  
      { positions }, { params: {}, observe: 'response' });
  }
}
